import React from "react";
import { Card, CardBody, Col, Container, Row } from "react-bootstrap";
import ProductForm from "./ProductForm";
import TbkProductList from "./TbkProductList";
import TelProductList from "./TelProductList";
import TelProductForm from "./TelProductForm";
import TbkProductListOne from "./TbkProductListOne";

const ProductPage = ({ data,isType }) => {
  return (
    <>
      <Container fluid className="p-2">
        <Row>
          <Col sm={7}>
            <Card className='shadow'>
              {
                isType=="tbk"?
                (<ProductForm data={data} />)
                :(<TelProductForm data={data}/>)
              }                
            </Card>
          </Col>
          <Col sm={5}>
            <Card className="shadow">
           
              {
                isType=="tbk"?
                (                  
                 <TbkProductListOne data={data}/>
                )
                :(<TelProductList data={data}/>)
              }
                              
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ProductPage;
